import { _formatCourse, _formatCourses } from '../../helpers'

const courseWithTopicLessons = state =>
  _formatCourse(state.courseWithTopicLessons)
const trending = state => _formatCourses(state.trending)
const popular = state => _formatCourses(state.popular)
const featured = state => _formatCourses(state.featured)
const newCourses = state => _formatCourses(state.newCourses)
const feedbackSubmission = state => state.feedbackSubmission
const allCourses = state => _formatCourses(state.allCourses)

export default {
  courseWithTopicLessons,
  trending,
  popular,
  featured,
  newCourses,
  feedbackSubmission,
  allCourses,
}
